import React from "react";
import { Box } from "@mui/material";

const scopeStatusConfig = {
  CREATED: {
    label: "Created",
    color: "#2563EB",
    bg: "#EFF6FF",
  },
  BID: {
    label: "In Bid",
    color: "#EA580C",
    bg: "#FFF7ED",
  },
  CONTRACTED: {
    label: "Contracted",
    color: "#16A34A",
    bg: "#F0FDF4",
  },
};

const StatusPill = ({ status }) => {
  const config = scopeStatusConfig[status];
  if (!config) return null;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: config.bg,
        color: config.color,
        fontSize: "12px",
        fontWeight: 600,
        padding: "4px 10px",
        borderRadius: "999px",
        fontFamily: "Inter Tight",
        whiteSpace: "nowrap",
      }}
    >
      {config.label}
    </Box>
  );
};

export default StatusPill;
